import Vue from "vue";
import lb from "../util/lb";

export default {
  SET_CURRENT_USER(state, data) {
    Vue.set(state, "user", data);
  },
  SET_ACCESS_TOKEN(state, data) {
    Vue.set(state, "accesstoken", data);
    lb.defaults.headers.common["Authorization"] = data;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js